import { render } from "./ProductModelSelector.vue?vue&type=template&id=97cbbe5e&scoped=true"
import script from "./ProductModelSelector.vue?vue&type=script&lang=js"
export * from "./ProductModelSelector.vue?vue&type=script&lang=js"

import "./ProductModelSelector.vue?vue&type=style&index=0&id=97cbbe5e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97cbbe5e"]])

export default __exports__